import React from "react";
import HistoryTCSearchForm from "./shared/history-tc-search-form.jsx";
import HistoryTCList from "./shared/history-tc-list.jsx";
import ajax from "./../lib/ajax.js";
import context from "./../lib/context.js";
import immutable from "immutable";
import {browserHistory} from 'react-router';

export default class PayrollAdminHistoryTC extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchForm: {
                timecardStatusList: [],
                companies: [],
                peopleList: [],
                selectedStatus: ""
            },
            timecardList: {
                timecards: [],
                total: 0 
            }
        }

        this.role = context.getRouteParam(this, "role");

        this.onTimecardStatusSelectionChange = this.onTimecardStatusSelectionChange.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onNavigate = this.onNavigate.bind(this);
        this.search = this.search.bind(this);
        this.getTimecardUrl = this.getTimecardUrl.bind(this);
    }

    componentDidMount() {
        context.message({
            show: true,
            type: "loading",
            message: "Loading. Please wait..."
        });

        this.loadViewModel();
    }

    onTimecardStatusSelectionChange(newStatus) {
        let clone = immutable.fromJS(this.state.search).toJS();
        clone.timecardStatus = newStatus;
        clone.page = 0;
        this.setState({search: clone}, this.search);
    }

    onNavigate(page) {
        let clone = immutable.fromJS(this.state.search).toJS();
        clone.page = page;
        this.setState({search: clone}, this.search);
    }

    onSearch(payload) {
        let clone = immutable.fromJS(this.state.searchForm).toJS();
        clone.selectedStatus = payload.timecardStatus;
        payload.page = this.state.search.page;
        payload.pageSize = this.state.search.pageSize;
        this.setState({search: payload, searchForm: clone}, this.search);
    }

    search() {
        let self = this;                
        let vm = self.state;        
        context.message({show:true, type: "loading", message:"Loading. Please wait..."});
        //ajax.api().get("get-timecard-by-status/payroll-admin/" + vm.search.timecardStatus + "/" + vm.search.monthEnding, {

        // Use ajax.api() when viewing timecard detail on REACTJS screen
        ajax.legacy().get(`get-timecard-by-status/${self.role}/${vm.search.timecardStatus}/${vm.search.monthEnding}`, {
            params : {
                assocName: vm.search.employeeName, 
                office: vm.search.office,
                company: vm.search.company,
                p: vm.search.page,
                pz: vm.search.pageSize
            }
        })
        .then(function(res) {
            res.data.page = vm.search.page;
            res.data.pageSize = vm.search.pageSize;
            self.setState({timecardList: res.data});
            context.message({show:false});
        })
        .catch(function(err) {
            let data = err.response.data;
            context.message({
                show: true,
                type: "error",
                message: data.exceptionMessage || data.message,
                buttons: "close"
            });
        });
    }

    loadViewModel() {
        const self = this;
        ajax.vm()
            .get(`${self.role}/history-tc`)
            .then(function (res) {
                let data = res.data;
                if (data.searchForm.companies.length == 0) {
                    let url = context.routeUrl("home?msg=Missing%20assigned%20company%20for%20Payroll%20Admin.%20Please%20contact%20Help%20desk");
                    browserHistory.push(url);
                    //window.location = url;
                }

                data.search = {page: 0, pageSize: 10};
                self.setState(res.data, self.refs.searchForm.onSearch);
                context.message({ show: false });
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });                    
            });
    }

    getTimecardUrl(tc) { // expected type: TimecardSummaryModel
        if (tc.timecardSummary.timecardType === "DURATIONTC") {
            //let submitted = tc.timecardSummary.statusCode === "Submitted" ? 1 : 0;
            //return context.url("..","People",`TimeSheet.aspx?tid=${tc.tId}&oid=${tc.timecardSummary.offsysId}` + 
            //    `&pid=${tc.timecardSummary.placementId}&ppid=${tc.ppId}&role=${tc.role}&submitted=${submitted}`);
            return context.routeUrl(`${this.role}/tc-duration/${tc.timecardSummary.timecardId}`);
        } else {
            //return context.url("..","People",`TimeClockEntry.aspx?token=${tc.token}`);
            return context.routeUrl(`${this.role}/tc-clock-edit/${tc.timecardSummary.timecardId}`);
        }
    }

    render() {
        const self = this;
        console.log(self.state);
        let idx = 0;
        let idx2 = 0;
        return (
            <div className="container">
                <div className="row hidden-sm hidden-xs">
                    <div className="col-md-12">
                        <h2 className="text-center ap-title">Payroll Admin Timecard History</h2>
                        <h3 className="text-center ap-sub-title">View/Edit Timecard - view and edit Submitted, Verified, Processed and Denied timecards</h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <datalist key="peopleDataList" id="peopleDataList">
                            {self.state.searchForm.peopleList.map(p => <option key={p.peopleId} value={p.fullName} />)}
                        </datalist>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <HistoryTCSearchForm vm={self.state.searchForm} onSearch={this.onSearch} onTimecardStatusSelectionChange={this.onTimecardStatusSelectionChange}
                            hideFilters="" ref="searchForm" />
                    </div>
                </div>
                <hr />
                <div className="row">
                    <div className="col-md-12">
                        <HistoryTCList vm={self.state.timecardList} role={this.role} hideColumns=""
                            onNavigate={this.onNavigate} onGetItemUrl={this.getTimecardUrl} />
                    </div>
                </div>
            </div>
        );
    }
}